import { useEffect } from 'react';

const BLOCKED_SHORTCUTS = new Set(['c', 'a', 's', 'p', 'u', 'x', 'v']);

/**
 * Best-effort desktop copy/screenshot deterrence for LMS course content.
 * True screenshot blocking is not possible in browsers; this reduces casual copying.
 */
export function useContentProtection(enabled = true) {
  useEffect(() => {
    if (!enabled || typeof document === 'undefined') {
      return undefined;
    }

    const preventDefault = (event) => {
      event.preventDefault();
      return false;
    };

    const handleCopy = (event) => {
      event.preventDefault();
      if (event.clipboardData) {
        event.clipboardData.setData('text/plain', '');
      }
    };

    const handleKeyDown = (event) => {
      const key = String(event.key || '').toLowerCase();
      if ((event.ctrlKey || event.metaKey) && BLOCKED_SHORTCUTS.has(key)) {
        event.preventDefault();
      }
      if (key === 'f12' || key === 'printscreen') {
        event.preventDefault();
      }
    };

    const handleKeyUp = async (event) => {
      if (event.key !== 'PrintScreen') {
        return;
      }
      try {
        await navigator.clipboard?.writeText?.('');
      } catch {
        // Clipboard API may be unavailable; ignore.
      }
    };

    document.addEventListener('contextmenu', preventDefault);
    document.addEventListener('copy', handleCopy);
    document.addEventListener('cut', handleCopy);
    document.addEventListener('selectstart', preventDefault);
    document.addEventListener('dragstart', preventDefault);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyUp);

    return () => {
      document.removeEventListener('contextmenu', preventDefault);
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('cut', handleCopy);
      document.removeEventListener('selectstart', preventDefault);
      document.removeEventListener('dragstart', preventDefault);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, [enabled]);
}

export const contentProtectionSx = {
  userSelect: 'none',
  WebkitUserSelect: 'none',
  MozUserSelect: 'none',
  msUserSelect: 'none',
  WebkitTouchCallout: 'none',
  '& img': {
    pointerEvents: 'none',
    WebkitUserDrag: 'none',
    userDrag: 'none',
  },
};
